module.exports = __webpack_public_path__ + "static/media/soumitra_tonapi.555c9340.jpeg";